import styles from '@src/main/modules/messages/ui/mailbox/views/mailbox/Mailbox.module.scss';
import ReportsTabContent from '@src/main/modules/reports/ui/components/ReportsTabContent';
import ContentCard from '@src/main/shared/ui/components/card/ContentCard';
import TabHeader from '@src/main/shared/ui/components/header/TabHeader';
import { TabMenuTabChangeEvent } from 'primereact/tabmenu';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const PositionAssignmentView = () => {
  const [activeIndex, setActiveIndex] = useState(2);
  const { t } = useTranslation();

  const items = [{ label: t('reports.menu.positionassignment'), icon: 'pi pi-inbox' }];

  const handleTabChange = (e: TabMenuTabChangeEvent) => {
    setActiveIndex(e.index);
  };

  return (
    <ContentCard>
      <TabHeader
        title={t('reports.menu.positionassignment')}
        items={items}
        activeIndex={activeIndex}
        onTabChange={handleTabChange}
      />
      <ReportsTabContent className={styles['tab-content']} activeIndex={activeIndex} />
    </ContentCard>
  );
};

export default PositionAssignmentView;
